export const TEST_IDS = {
  emailInput: {
    inputElement: 'emailInput',
    hasError: 'email.hasError',
    success: 'email.success',
  },
};